<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
    <div class="row py-lg-5">
        <div class="col-sm-6 offset-sm-3 project-content">
            <mdb-card>
                <!-- Project's informations -->
                <mdb-card-title>
                    <!-- Project Title -->
                    <h2>CREATION DE MON CV EN WEB (HTML CSS) </h2>
                    <!-- Project date + duration -->
                    <h4><b>Fin :</b> Juin 2021</h4>
                    <h4><b>Durée :</b> 3 mois</h4>
                </mdb-card-title>
                <!-- Project image -->
                <mdb-card-img class="project-picture" src="assets/cvv.png"></mdb-card-img>
                <!-- About the project -->
                <mdb-card-body>
                    <!-- Technologies used -->
                    <div class="row technos">
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Technologies : </b></h4>
                                <img class="dot" src="assets/skills/html.png" />
                                <img class="dot" src="assets/skills/css.png" />
                                <img class="dot" src="assets/skills/github.png" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row">
                                <h4><b>Tags : </b></h4>
                                <p> Html, Css , Github</p>
                            </div>
                        </div>
                    </div>
                    <div class="row description">
                        <!-- Description of the project -->
                        <div class="col-sm-6">
                            <h4><b>Description :</b></h4>
                            <p>
                                J'ai décidé de créer mon cv en HTML et en CSS je trouve cela intéressant surtout en tant que développeur Web
                            </p>
                        </div>
                        <!-- Apports du projet -->
                        <div class="col-sm-6">
                            <h4><b>Bilan :</b></h4>
                            <p>

                            </p>
                        </div>
                        <li><a href="https://portfolio-coleau.000webhostapp.com/cv.html" target="blank">Mon CV </a></li>

                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</div>

<app-projects></app-projects>